import { FunctionComponent } from "react";
import { GuardedProps } from "./guarded-route";
import useGuarded from "./use-guarded";

const GuardedElement: FunctionComponent<GuardedProps> = ({
  permissions,
  children,
  preventSuperAdminAccess,
  onlySuperAdminAccess,
}) => {
  const allowed = useGuarded(
    permissions,
    preventSuperAdminAccess,
    onlySuperAdminAccess
  );
  if (allowed) {
    return children;
  }
  return null;
};

export default GuardedElement;
